import Swiper, { Navigation, Pagination } from 'swiper';

export default class ReasonsToBuy {
  constructor() {
    this.slider = document.querySelector('.js-reasons-to-buy-slider');

    this.init();
  }

  init() {
    if (this.slider) {
      const slides = this.slider.querySelectorAll('.swiper-slide');
      const paginationEl = this.slider
        .closest('.container')
        .querySelector('.swiper-pagination');

      const swiper = new Swiper(this.slider, {
        modules: [Navigation, Pagination],
        loop: false,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: this.slider.querySelector('.swiper-button-next'),
          prevEl: this.slider.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false,
        },
        on: {
          init: function () {
            const images = this.el.querySelectorAll('img.lazyload');
            images.forEach((img) => {
              img.addEventListener('load', () => {
                this.updateAutoHeight();
              });
              img.addEventListener('lazyloaded', () => {
                this.updateAutoHeight();
              });
            });
          },
          slideChange: function () {
            setTimeout(() => {
              this.updateAutoHeight();
            }, 100);
          },
        },
        breakpoints: {
          1024: {
            autoHeight: false,
          },
        },
      });
    } else {
      console.log('Slider not found');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new ReasonsToBuy();
});
